export class ComprovacaoOcorrenciaDTO{
  id: number;
  idComprovacaoWeb: number;
  matricula: string;
  tipo: string;
  ocorrencia: string;
  responsavel: string;
  dataOcorrencia: Date;
}